/* eslint-disable react/jsx-key */
import { TextLegacy } from '@/components/common'
import { FontResponsiveSizeType } from '@/components/common/texts/TextBase'

const PolicyAgreement = ({ fontSize = { xs: 12, md: 14 } }: { fontSize?: FontResponsiveSizeType }) => {
  /**
   * 이용약관 변경 및 생성시 스타일 표시 용도
   * ex) <span style={changedStyle}>변경</span>
   * isShowChangedStyle props 추가 이전 커밋 참고
   */
  // const changedStyle = isShowChangedStyle
  //   ? {
  //       textDecoration: 'underline',
  //     }
  //   : {}
  const textSplitList = [
    <div>
      1장 총칙
      <br />
      <br />
      <br />
      제1조(목적) 이 약관은 주식회사 핏펫(이하 “회사”라 합니다)이 운영하는 자사 온라인 쇼핑몰과
      웹사이트(www.fitpet.co.kr/, www.fitpetmall.com, 이하 “웹”이라 합니다), 자사 모바일기기용 애플리케이션(이하
      “앱”이라 합니다)을 통하여 제공하는 반려동물 소변검사, 모발검사, 유전병검사 전자상거래 및 기타 관련 서비스(이하
      “서비스”라 합니다)를 이용함에 있어 회사와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제2조(정의)
      <br />
      ①이 약관에서 사용하는 주요한 용어의 정의는 다음과 같습니다.
      <br />
      1. “사이버몰 웹사이트(웹)”란 회사가 재화와 서비스 등(이하 “재화 등”이라 함)을 이용자에게 제공하기 위하여 컴퓨터 등
      정보통신설비를 이용하여 재화 등을 거래할 수 있도록 설정한 가상의 영업장을 말합니다.
      <br />
      2. “애플리케이션(앱)”이란 회사가 제공하는 서비스를 이용하기 위하여 모바일 기기를 통해 다운로드 받거나 설치하여
      사용하는 프로그램 일체를 의미합니다.
      <br />
      3. “모바일 기기”란 콘텐츠를 다운로드 받거나 설치하여 사용할 수 있는 기기로서, 휴대폰, 스마트폰,
      휴대정보단말기(PDA), 태블릿 등을 의미합니다.
      <br />
      4. “이용자”란 “웹” 또는 “앱”에 접속하여 이 약관에 따라 회사가 제공하는 서비스를 받는 회원과 비회원을 말합니다.
      <br />
      5. “회원”이란 회사가 정한 가입절차에 따라 “회사”의 승낙을 받아 “웹” 또는 “앱” 에 회원등록을 한 자로서, 계속적으로
      “회사”가 제공하는 서비스를 이용할 수 있는 자를 말합니다.
      <br />
      6. “비회원”이란 회원에 가입하지 않고 “회사”가 제공하는 서비스를 이용하는 자를 말합니다.
      <br />
      7. “아이디(ID)”란 회원의 식별과 회원의 서비스 이용을 위하여 회원이 설정하고 “회사”가 승인하여 “회사”에 등록된
      영문, 숫자 또는 영문과 숫자의 조합을 말합니다.
      <br />
      8. “비밀번호(Password)”란 회원인지를 확인하고 비밀을 보호하기 위하여 회원이 스스로가 설정해 “회사”에 등록한 영문과
      숫자와 특수문자의 조합을 말합니다.
      <br />
      9. “운영자”란 “회사”에서 제공하는 서비스의 전반적인 관리와 원활한 운영을 위하여 “회사”에서 선정한 자를 말합니다.
      <br />
      10. “상품”이란 “회사” 에서 제공하는 서비스를 이용하기 위해 온,오프라인을 통해 구매한 자사의 검사 도구 등을
      말합니다.
      <br />
      <span>
        11. “제휴 수의사”란 “회사”가 제공하는 서비스를 통해 “회원”에게 상담 서비스 제공, 병원 연계 진행, 반려동물 정보
        확인, 통계 작성 등의 서비스를 제공하는 수의사를 의미합니다.
      </span>
      <br />
      <span>
        12. “제휴 병원”이란 “회사” 및 “회사”의 업무를 위탁받은 중개업체와 제휴계약을 체결하여 “회사”가 제공하는
        “병원예약 서비스”를 통해 회원에게 예약거래를 제공하는 동물병원을 의미합니다.
      </span>
      <br />
      <span>
        13. “병원찾기 서비스”란 “회사”가 “웹” 또는 “앱”을 통해 회원에게 제공하는 병원정보(위치, 운영시간 등) 제공
        서비스를 의미합니다.
      </span>
      <br />
      <span>14. “병원예약 서비스”란 “회사”가 회원과 “제휴 병원”간 예약거래를 중개하는 서비스를 의미합니다.</span>
      <br />
      15. “셀러판매 서비스”란 “회사”가 “웹” 또는 “앱”을 통해 회원에게 제공하는 통신판매중개 서비스 및 관련 부가 서비스
      일체를 의미합니다.
      <br />
      16. “판매자”란 “셀러판매 서비스”를 통해 실제로 상품을 판매하는 자를 말합니다.
      <br />
      17. “회원 등급“이란 회사가 일정한 기준에 따라 회원에게 부여하는 등급으로, 등급별 혜택은 홈페이지 내 별도의
      화면에서 공지합니다.
      <br />
      ② 본 조에서 정의되지 않은 용어의 의미는 관련 법령 및 일반적인 거래관행을 따릅니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제3조 (약관 등의 명시와 설명 및 개정)
      <br />
      ① “회사”는 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를
      포함), 전화번호·모사전송번호·전자우편주소, 사업자등록번호, 통신판매업 신고번호, 개인정보관리책임자 등을 이용자가
      쉽게 알 수 있도록 “웹”의 초기 서비스화면(www.fitpet.co.kr/, www.fitpetmall.com)과 “앱”의 서비스화면에 게시합니다.
      다만, 약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.
      <br />
      ② “회사”는 이용자가 약관에 동의하기에 앞서 약관에 정하여져 있는 내용 중 청약철회·배송책임·환불조건 등과 같은
      중요한 내용을 이용자가 이해할 수 있도록 별도의 연결화면 또는 팝업화면 등을 제공하여 이용자의 확인을 구하여야
      합니다.
      <br />
      ③ “회사”는 합리적인 사유가 발생하면 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」,
      「전자문서 및 전자거래기본법」, 「전자금융거래법」, 「전자서명법」, 「정보통신망 이용촉진 및 정보보호 등에 관한
      법률」, 「방문판매 등에 관한 법률」, 「소비자기본법」 등 관련 법을 위배하지 않는 범위에서 이 약관을 개정할 수
      있습니다.
      <br />
      ④ “회사”가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 “웹”의 초기 서비스화면(전면)과
      “앱”의 서비스화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만, 이용자에게 불리하게 약관내용을
      변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지하며, 이메일(e-mail), 문자메시지(SMS) 등으로
      이용자에게 개별 통지합니다(이용자의 연락처 미기재, 변경 등으로 개별 통지가 어려울 때에는 본 약관에 따라 공지를
      하는 것을 개별 통지한 것으로 간주합니다). 이 경우 “회사”는 개정 전 내용과 개정 후 내용을 명확하게 비교하여
      이용자가 알기 쉽도록 표시합니다.
      <br />
      ⑤ 이 약관에 동의하는 것은 정기적으로 “회사”가 운영하는 인터넷 사이트를 방문하여 약관의 변경사항을 확인하는 것에
      동의함을 의미합니다. 본 조 소정의 절차를 거쳐 변경된 약관에 대한 정보를 알지 못하여 발생하는 회원 또는 이용자의
      피해에 대해 “회사”는 책임을 지지 않습니다.
      <br />
      ⑥ “회사”가 이 약관을 개정할 경우에는 그 개정약관은 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미
      체결된 계약에 대해서는 개정 전의 약관조항이 그대로 적용됩니다. 다만 이미 계약을 체결한 이용자가 개정약관 조항의
      적용을 받기를 원하는 뜻을 제4항에 의한 개정약관의 공지기간 내에 “회사”에 송신하여 “회사”의 동의를 받은 경우에는
      개정약관 조항이 적용됩니다.
      <br />
      ⑦ 변경된 약관에 동의하지 않는 회원은 “회사”에 대하여 회원탈퇴를 요청할 수 있으며, “회사”가 명시한 변경약관
      적용일까지 회원탈퇴를 요청하지 않은 이용자는 변경된 약관에 동의한 것으로 봅니다.
      <br />
      ⑧ “회사”는 필요한 경우 이 약관과 별도로 특정 서비스에 적용될 “개별약관” 또는 서비스 이용과 관련된 세부적인 사항을
      정한 “운영정책”을 정하여 안내할 수 있습니다.
      <br />
      ⑨ 개별약관, 운영정책과 본 약관 규정이 충돌할 경우 신 규정이 우선 적용됩니다.
      <br />
      ⑩ 개별 약관이나 운영정책의 변경이 있는 경우 “회사”는 변경내용의 효력발생일 7일 이전에 “웹” 및 “앱”을 통하여 해당
      변경사항을 공지합니다.
      <br />
      ⑪ 이 약관, 개별약관 및 운영정책에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 「전자상거래 등에서의
      소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 「공정거래위원회가 정하는 전자상거래 등에서의 소비자
      보호지침」 및 관계법령 또는 상관례에 따릅니다.
      <br />
      <br />
      <br />
      <br />
    </div>,
    <div>
      2장 서비스 제공 및 이용
      <br />
      제4조(서비스의 제공 및 변경)
      <br />
      ① “회사”는 다음과 같은 업무를 수행합니다.
      <br />
      1. “웹“과“앱“에서 발생한 재화 등에 대한 정보 제공 및 구매계약의 체결, 통신판매중개서비스 및 이에 수반되는 기타
      서비스
      <br />
      2. “웹“과“앱“에서 발생한 구매계약이 체결된 재화의 배송 또는 서비스의 제공
      <br />
      3. 반려동물과 관련된 정보제공
      <br />
      4. “병원찾기 서비스” 및 “병원예약 서비스”의 제공
      <br />
      5. 기타 “회사”가 정하는 업무
      <br />
      ② “회사”는 제6조의 규정에 따라 이용계약이 완료된 회원에게 그 즉시 서비스를 이용할 수 있도록 합니다. 다만, 일부
      서비스의 경우 “회사”의 필요에 따라 지정된 일자부터 서비스를 개시할 수 있습니다.
      <br />
      ③ “회사”는 회원에게 서비스를 제공할 때 이 약관에서 정하고 있는 서비스를 포함하여 기타 부가적인 서비스를 함께
      제공할 수 있습니다.
      <br />
      ④ 서비스는 업무상, 기술상 특별한 지장이 없는 한 연중 무휴, 1일 24시간 제공을 원칙으로 하되 제5조에 따라 중단할 수
      있습니다. 단, 상담에 대한 답변, 고객센터 운영 등 “웹” 또는 “앱”에서 직접 제공되지 않는 서비스는 “회사”가 지정한
      운영시간에만 제공됩니다.
      <br />
      ⑤ “회사”는 모바일 기기를 위한 전용 애플리케이션 또는 네트워크를 이용하여 서비스를 제공하며, 회원은 애플리케이션을
      다운로드하여 설치하거나 네트워크를 이용하여 무료 또는 유료로 서비스를 이용할 수 있습니다.
      <br />
      ⑥ 유료콘텐츠의 경우 해당 서비스에 명시된 요금을 지급하여야 이용할 수 있습니다. 네트워크를 통해 애플리케이션을
      다운로드하거나 서비스를 이용하는 경우에는 가입한 이동통신사에서 정한 별도의 요금이 발생할 수 있습니다.
      <br />
      ⑦ 다운로드하여 설치한 애플리케이션 또는 네트워크를 통해 이용하는 서비스의 경우에는 모바일기기 또는 이동통신사의
      특성에 맞게 제공됩니다. 모바일 기기의 변경, 번호변경 또는 해외로밍의 경우 콘텐츠의 전부 또는 일부의 이용이
      불가능할 수 있으며, 이로 인한 손해는 “회사”가 책임지지 않습니다.
      <br />
      ⑧ 다운로드하여 설치한 애플리케이션 또는 네트워크를 통해 이용하는 서비스의 경우에는 백그라운드 작업이 진행될 수
      있습니다. 이 경우 모바일기기 또는 이동통신사 특성에 맞도록 추가요금이 발생할 수 있으며 이와 관련하여 “회사”는
      책임을 지지 않습니다.
      <br />
      ⑨ “회사”는 재화 등의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화 등의 내용을
      변경할 수 있습니다. 이 경우에는 변경된 재화 등의 내용 및 제공일자를 명시하여 현재의 재화 등의 내용을 게시한 곳에
      즉시 공지합니다.
      <br />
      ⑩ “회사”가 제공하기로 이용자와 계약을 체결한 서비스의 내용을 재화 등의 품절 또는 기술적 사양의 변경 등의 사유로
      변경할 경우에는 그 사유를 이용자에게 통지 가능한 주소로 즉시 통지합니다.
      <br />
      <br />
    </div>,
    <div>
      제4조의2(병원예약 서비스 책임 제한)
      <br />
      <span>
        ① “회사“는 “회원”과 “제휴 병원“ 간의 편리한 예약거래를 위한 “병원예약 서비스”를 운영 및 관리, 제공할 뿐이며
        “회원” 또는 “제휴 병원”을 대리하지 않습니다. 회사의 고의 또는 중대한 과실이 없는 이상 “회원”과 “제휴 병원”
        사이에 성립된 거래 및 “제휴 병원”이 제공하고 등록한 정보에 대해서는 해당 “제휴 병원”이 단독으로 책임을
        부담합니다.
      </span>
      <br />
      <span>
        ② “회사”는 직접 예약권 등을 구매하여 판매하지 않으며, 단지 “제휴 병원”과 “회원” 간의 예약 거래의 편의성을
        증진시키는 “병원예약 서비스”를 개발 및 제공합니다.
      </span>
      <br />
      <br />
    </div>,
    <div>
      제5조(서비스의 중단)
      <br />
      ① “회사”는 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등 정상적인 서비스가 불가능한 사유가 발생한
      경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.
      <br />
      ② “회사”는 제1항의 사유로 서비스의 제공이 일시적으로 중단되는 경우 서비스 일시 중단 사실과 그 사유를 “웹” 또는
      “앱”의 초기화면에 통지합니다. 단, 긴급점검, 정전 등 사전공지가 불가능한 경우 서비스 재개 후 통지할 수 있습니다.
      <br />
      ③ “회사”는 국가비상사태 발생, 천재지변 기타 불가항력으로 인하여 서비스를 제공할 수 없으면 서비스 제공을 제한하거나
      일시 중단할 수 있습니다. 이 경우 서비스 재개 후 즉시 그 사유를 “웹” 또는 “앱”의 초기화면에 통지합니다
      <br />
      <br />
      <br />
      <br />
    </div>,
    <div>
      3장 회원가입, 탈퇴 및 서비스의 이용
      <br />
      제6조(회원가입 및 이용계약의 체결)
      <br />
      ① 이용계약은 “웹” 또는 “앱”을 통하여 서비스를 제공받고자 하는 이용자가 이 약관에 동의하고 회원가입의 의사를
      표시하면 “회사”가 이를 승낙함으로써 성립합니다.
      <br />
      ② 이용자는 “회사”가 정한 가입 양식에 따라 회원정보(성별, 생일, 이용자ID, 비밀번호, 반려동물정보)를 기입한 후 이
      약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.
      <br />
      ③ “회사”는 제1항과 같이 회원으로 가입할 것을 신청한 이용자가 다음 각 호에 해당하지 않는 한 승낙의 의사를 표시하고
      회원으로 등록합니다.
      <br />
      1. 가입신청자가 이 약관 제7조제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 다만 제7조제3항에 의한
      회원자격 상실 후 3년이 경과한 자로서 “회사”의 회원재가입 승낙을 얻은 경우에는 예외로 합니다.
      <br />
      2. 등록 내용에 허위, 기재누락, 오기가 있는 경우
      <br />
      3. 탈퇴 후 90일 내 재가입을 신청하는 경우
      <br />
      4. 기타 회원으로 등록하는 것이 “웹” 또는 “앱”의 기술상 현저히 지장이 있다고 판단되는 경우
      <br />
      ④ 이용계약의 성립 시기는 “회사”의 이용승낙 의사가 “웹” 또는 “앱”의 서비스화면에 게시되거나, 이메일(E-mail) 기타
      “회사”가 정하는 방법으로 가입신청자에게 도달한 시점으로 합니다.
      <br />
      ⑤ 회원은 회원가입 시 등록한 사항에 변경이 있는 경우, 상당한 기간 이내에 “회사”에 대하여 회원정보 수정 등의
      방법으로 그 변경사항을 알려야 합니다. 단, 이름, 아이디(ID) 등 변경할 수 없는 사항은 수정할 수 없습니다.
      <br />
      ⑥ 수정하지 않은 정보로 말미암아 발생하는 손해는 회원이 부담하며, “회사”는 이에 대하여 아무런 책임을 부담하지
      않습니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제7조(회원 탈퇴 및 자격 상실 등)
      <br />
      ① 회원은 “회사”에 언제든지 탈퇴를 요청하여 이용계약을 해지할 수 있으며 “회사”는 즉시 회원탈퇴를 처리합니다. 단,
      회원탈퇴 및 이용계약 해지의 의사를 통지하기 전에 현재 진행중인 모든 재화 등의 거래를 완료하거나 철회 또는
      취소하여야 합니다. 이 경우 거래의 철회 또는 취소로 인한 불이익은 회원이 부담합니다.
      <br />
      ② 회원이 다음 각 호의 사유에 해당하는 경우, “회사”는 회원자격을 제한 및 정지시킬 수 있습니다.
      <br />
      1. 가입 신청 시 또는 회원정보 변경 시에 허위 내용을 등록한 경우
      <br />
      2. “웹” 또는 “앱”을 이용하여 구입한 재화 등의 대금, 기타 “웹” 또는 “앱” 이용에 관련하여 회원이 부담하는 채무를
      기일에 지급하지 않는 경우
      <br />
      3. 다른 사람의 “웹” 또는 “앱” 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우
      <br />
      4. “웹” 또는 “앱” 을 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우
      <br />
      5. 구매한 상품 또는 서비스에 특별한 하자가 없음에도 상습적으로 사용 후 취소, 반품 등을 하는 경우
      <br />
      6. “회사”의 운영진, 직원 또는 관계자를 사칭하는 경우
      <br />
      7. 다른 회원의 ID를 부정하게 사용하는 경우
      <br />
      8. 다른 회원의 개인정보를 그 동의 없이 수집, 저장, 공개하는 경우
      <br />
      9. “회사”, 기타 제3자의 인격권 또는 지적재산권을 침해하거나 업무를 방해하는 등 타인의 법익을 침해하는 경우
      <br />
      10. 기타 회원이 본 계약 제22조 또는 관련 법령에 위반하는 경우
      <br />
      ③ “회사”가 회원 자격을 제한·정지 시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지
      아니하는 경우 “회사”는 회원자격을 상실시킬 수 있습니다.
      <br />
      ④ “회사”가 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 “회사는” 이메일(E-mail), 전화, 팩스,
      기타의 방법으로 해지 사유를 밝혀 회원에게 해지의사를 통지하고, 회원등록 말소 전에 최소한 30일 이상의 기간을 정하여
      소명할 기회를 부여합니다.
      <br />
      ⑤ 회원의 회원탈퇴의사, “회사”의 해지의사가 상대방에게 도달한 시점(E-mail 등의 경우 상대방의 편지함에서 확인가능한
      시점에 도달한 것으로 봅니다)에 이용계약이 종료됩니다.
      <br />
      ⑥ 회원탈퇴의사가 “회사”에 도달하면 “회사”가 보유한 서비스 관련 프로그램이 자동으로 삭제되며, “회사”와 회원은 해당
      정보를 확인할 수 없습니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제8조(회원에 대한 통지)
      <br />
      ① “회사”가 회원에 대한 통지를 하는 경우, 회원이 “회사”와 미리 약정하여 지정한 이메일(E-mail) 주소로 할 수
      있습니다.
      <br />
      ② “회사”는 불특정 다수 회원에 대한 통지의 경우 이 약관에 다른 정함이 없으면 1주일이상 “웹” 또는 “앱”을 통해
      공고함으로써 개별 통지에 갈음할 수 있습니다. 다만, 회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에
      대하여는 개별통지를 합니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제9조(구매신청 및 개인정보 제공 동의 등)
      <br />
      “웹” 또는 “앱” 이용자는 “웹”(“앱”의 경우 구매버튼을 통하여 연결된 “웹” 포함)상에서 다음 또는 이와 유사한 방법에
      의하여 구매를 신청하며, “회사”는 이용자가 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다.
      <br />
      1. 재화 등의 검색 및 선택
      <br />
      2. 청약철회권이 제한되는 서비스, 배송료 등의 비용부담과 관련한 내용에 대한 확인
      <br />
      3. 위 제2호의 사항을 확인하거나 거부하는 표시(예, ‘구매’, ‘결제하기’ 등 통상적으로 구매의 신청을 의미하는 버튼을
      클릭)
      <br />
      4. 재화 등의 구매신청 및 이에 관한 확인 또는 “회사”의 확인에 대한 동의
      <br />
      5. 결제방법의 선택
      <br />
      <br />
      <br />
      <br />
    </div>,
    <div>
      제10조 (개별 물품, 개별 서비스 이용계약의 성립)
      <br />
      ① “회사”는 제9조와 같은 구매신청에 대하여 다음 각 호에 해당하면 승낙하지 않을 수 있습니다.
      <br />
      1. 신청 내용에 허위, 기재누락, 오기가 있는 경우
      <br />
      2. 기타 구매신청에 승낙하는 것이 “웹” 또는 “앱” 기술상 현저히 지장이 있다고 판단하는 경우
      <br />
      ② “회사”의 승낙이 “웹” 또는 “앱”의 서비스화면에 게시되거나, 이메일(E-mail) 기타 “회사”가 정하는 방법으로
      구매신청자에게 도달한 시점에 계약이 성립한 것으로 봅니다.
      <br />
      <br />
      <br />
      <br />
    </div>,
    <div>
      제11조 (회원 등급 및 혜택)
      <br />
      ① 회사는 회원이 재화 등을 구매한 금액, 횟수 등 일정한 기준에 따라 회원에게 소정의 등급을 부여할 수 있고, 각
      등급별로 일정한 혜택을 부여할 수 있습니다.
      <br />
      ② 회사가 회원에게 부여하는 등급, 등급의 산정 기준 및 혜택에 관한 제반 사항은 홈페이지 내 별도의 화면에 공지하며,
      관련 법령에서 정한 절차에 따라 사전 공지 후 변경될 수 있습니다.
      <br />
      ③ 회원 등급은 회원의 신용 또는 금융 신용 상태를 보증하지 않습니다.
      <br />
      <br />
      <br />
      <br />
    </div>,
    <div>
      제12조(지급방법) “웹” 또는 “앱” 에서 구매한 재화 등에 대한 대금 지급방법은 다음 각 호의 방법 중 가용한 방법으로 할
      수 있습니다. 단, “회사”는 이용자의 지급방법에 대하여 재화 등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수
      없습니다.
      <br />
      1. 폰뱅킹, 인터넷뱅킹, 메일 뱅킹 등의 각종 계좌이체
      <br />
      2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제
      <br />
      3. 온라인무통장입금
      <br />
      4. 전자화폐에 의한 결제
      <br />
      5. 수령 시 대금지급
      <br />
      6. 마일리지 등 “몰”이 지급한 포인트에 의한 결제
      <br />
      7. “몰”과 계약을 맺었거나 “몰”이 인정한 상품권에 의한 결제
      <br />
      8. 기타 전자적 지급 방법에 의한 대금 지급 등<br />
      <br />
      <br />
    </div>,
    <div>
      제13조(수신확인통지, 구매신청 변경·취소 및 주문취소)
      <br />
      ① “회사”는 이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를 합니다.
      <br />
      ② 수신확인통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및
      취소를 요청할 수 있고 “회사”는 배송 전에 이용자의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리하여야 합니다.
      다만 이미 대금을 지불한 경우에는 제16조의 청약철회 등에 관한 규정에 따릅니다.
      <br />
      ③ 이용자가 재화 등을 주문한 후 3영업일 이내에 대금을 결제하지 않으면 주문취소로 간주되고, 해당 주문은 자동으로
      취소됩니다.
      <br />
      ④ “회사”는 구매자가 매매대금 결제 때 사용한 결제수단에 대해 정당한 사용권한이 있는지 확인할 수 있으며, 이에 대한
      확인이 완료될 때까지 거래진행을 중지하거나 해당 거래를 취소할 수 있습니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제14조(재화 등의 공급)
      <br />
      ① “회사”는 이용자와 재화 등의 공급시기에 관하여 별도의 약정이 없는 이상, 이용자가 청약 및 대금지급을 한 날부터 7일
      이내에 재화 등을 배송, 제공할 수 있도록 주문제작, 포장 등 기타의 필요한 조치를 취합니다. 다만, 생산일정 지연,
      명절배송 등 부득이한 사정이 있는 경우 해당 사정을 고지하여 배송일정을 변경할 수 있습니다. 이때 “회사”는 이용자가
      재화 등의 공급 절차 및 진행 사항을 확인할 수 있도록 적절한 조치를 합니다.
      <br />
      ② “회사”는 이용자가 구매한 재화에 대해 배송수단, 수단별 배송비용 부담자, 수단별 배송기간 등을 명시합니다.
      <br />
      ③ 이용자는 재화 등을 구매하기 전에 재화 등의 상세 내용과 거래의 조건을 정확하게 확인하여야 하며, 해당 내용을
      확인하지 않고 구매하여 발생한 손실과 손해는 이용자가 부담합니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제15조(환급) “회사”는 이용자가 구매신청한 재화 등이 품절 등의 사유로 인도 또는 제공을 할 수 없을 때에는 지체 없이
      그 사유를 이용자에게 통지하고 사전에 재화 등의 대금을 받은 경우에는 대금을 받은 날부터 3영업일 이내에 환급하거나
      환급에 필요한 조치를 취합니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제16조(청약철회 등)
      <br />
      ① “회사”와 재화 등의 구매에 관한 계약을 체결한 이용자는 「전자상거래 등에서의 소비자보호에 관한 법률」 제13조
      제2항에 따른 계약내용에 관한 서면을 받은 날(그 서면을 받은 때보다 재화 등의 공급이 늦게 이루어진 경우에는 재화
      등을 공급받거나 재화 등의 공급이 시작된 날을 말합니다)부터 7일 이내에는 청약의 철회를 할 수 있습니다. 다만,
      청약철회에 관하여 「전자상거래 등에서의 소비자보호에 관한 법률」에 달리 정함이 있는 경우에는 동 법 규정에
      따릅니다.
      <br />
      ② 이용자는 재화 등을 배송 받은 경우 다음 각 호에 해당하는 경우에는 반품 및 교환을 할 수 없습니다.
      <br />
      1. 이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우(다만, 재화 등의 내용을 확인하기 위하여 포장 등을
      훼손한 경우에는 청약철회를 할 수 있습니다)
      <br />
      2. 이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우
      <br />
      3. 시간의 경과에 의하여 재판매가 곤란할 정도로 재화 등의 가치가 현저히 감소한 경우
      <br />
      4. 복제가 가능한 경우 그 원본인 재화 등의 포장을 훼손한 경우
      <br />
      5. 용역 또는 「문화산업진흥 기본법」 제2조 제5호의 디지털콘텐츠의 제공이 개시된 경우. (다만, 가분적 용역 또는
      가분적 디지털콘텐츠로 구성된 계약의 경우에는 제공이 개시되지 아니한 부분
      <br />
      에 대하여는 그러하지 아니함)
      <br />
      ③ 제2항제2호 내지 제4호의 경우에 “회사”가 사전에 청약철회 등이 제한되는 사실을 소비자가 쉽게 알 수 있는 곳에
      명기하거나 시용상품을 제공하는 등의 조치를 하지 않았다면 이용자의 청약철회 등이 제한되지 않습니다.
      <br />
      ④ 이용자는 제1항 및 제2항의 규정에 불구하고 재화 등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행된
      때에는 당해 재화 등을 공급받은 날부터 3월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회 등을
      할 수 있습니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제17조(청약철회 등의 효과)
      <br />
      ① “회사”는 이용자에게 재화를 공급한 경우 이용자로부터 재화를 반환받은 날 또는 “회사”가 용역 또는 디지털콘텐츠를
      공급하거나, 재화 등을 공급하지 아니한 경우는 청약철회를 한 날부터 영업일 기준 5~7 일 이내(PG 사 처리 기간 포함)에
      이미 지급받은 재화 등의 대금을 환급합니다. 이 경우 “회사”가 이용자에게 재화 등의 환급을 지연한 때에는 그
      지연기간에 대하여 「전자상거래 등에서의 소비자보호에 관한 법률 시행령」에서 정하는 지연이자율을 곱하여 산정한
      지연이자를 지급합니다.
      <br />
      ② “회사”는 위 대금을 환급함에 있어서 이용자가 신용카드 또는 전자화폐 등의 결제수단으로 재화 등의 대금을 지급한
      때에는 지체 없이 당해 결제수단을 제공한 사업자로 하여금 재화 등의 대금의 청구를 정지 또는 취소하도록 요청합니다.
      <br />
      ③ 청약철회 등의 경우 공급받은 재화 등의 반환에 필요한 비용은 이용자가 부담합니다. “회사”는 이용자에게 청약철회
      등을 이유로 위약금 또는 손해배상을 청구하지 않습니다. 다만 재화 등의 내용이 표시·광고 내용과 다르거나 계약내용과
      다르게 이행되어 청약철회 등을 하는 경우 재화 등의 반환에 필요한 비용은 “회사“가 부담합니다.
      <br />④ 이용자가 재화 등을 제공받을 때 발송비를 부담한 경우에 “회사”는 청약철회 시 그 비용을 누가 부담하는지를
      이용자가 알기 쉽도록 명확하게 표시합니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제18조(적립금)
      <br />
      ① “회사“는 회원의 구매활동, 이벤트 참여 등에 따라 회원에게 일정한 적립금을 부여할 수 있습니다.
      <br /> ② 회원은 적립금을 “회사“에서 상품 등의 구매 시 결제수단으로 사용할 수 있으며, “회사“는 적립금의 적립기준,
      사용방법, 사용기간 및 제한에 대한 사항을 사이트에 별도로 게시하거나 통지합니다. 적립금의 사용조건에 관한 사항은
      “회사“의 정책에 따라 달라질 수 있습니다.
      <br /> ③ 적립금은 현금으로 환급될 수 없습니다.
      <br />
      ④ 회원은 적립금을 제3자에게 또는 다른 아이디로 양도할 수 없으며, 유상으로 거래하거나 현금으로 전환할 수 없습니다.
      <br />
      ⑤ “회사“는 회원이 허위정보 제공 등의 부정한 방법으로 적립금을 획득하거나 부정한 목적이나 용도로 적립금을 사용하는
      경우 적립금의 사용을 제한하거나 적립금을 사용한 구매신청을 취소하거나 회원가격을 정지할 수 있습니다. <br />
      ⑥ 회원탈퇴 시 미사용한 적립금은 즉시 소멸되며, 탈퇴 후 재가입하더라도 소멸된 적립금은 복구되지 아니합니다.
      <br />
      ⑦ “회사”는 일정한 기준에 따라 회원의 등급을 산정하며, 등급에 따라 적립금 적립율, 배송비 혜택, 쿠폰 발급 등 혜택을
      차등 제공할 수 있습니다. 세부 기준 및 혜택은 홈페이지 내 별도의 화면을 통해 공지합니다
      <br />
      ⑧ 적립금은 적립금 지급일로부터 일정기간의 유효기간을 가지며, 유효기간이 경과된 적립금은 소멸되어 사용할 수
      없습니다.
      <br />
      ⑨ 회원등급 및 적립금 상세 내용은 “웹”의 FAQ 공지에 명시합니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      4장 당사자 권리와 의무
      <br />
      제19조(개인정보처리방침)
      <br />
      “회사”는 이용자의 개인정보 수집시 서비스제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집하며, 개인정보보호에
      관하여 관계법령 및 “회사”가 별도로 정하는 개인정보처리방침에 정한 바에 따라 회원등록정보 및 회원의 개인정보를
      보호하기 위하여 노력합니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제20조(“회사“의 의무)
      <br />
      ① “회사”는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고,
      안정적으로 재화 등을 제공하는데 최선을 다하여야 합니다.
      <br />
      ② “회사”는 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함)보호를 위한 보안
      시스템을 갖추어야 합니다.
      <br />
      ③ “회사”는 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제21조(“회원“의 ID 및 비밀번호에 대한 의무) <br />
      ① “회원”은 ID와 비밀번호에 관한 관리책임을 부담합니다.
      <br />
      ② 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.
      <br />
      ③ 회원이 자신의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 “회사”에 통보하고
      “회사”의 안내가 있는 경우에는 그에 따라야 합니다.
      <br />
      ④ “회사”는 회원의 귀책사유로 인하여 노출된 정보에 대하여 일체의 책임을 지지 않습니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제22조(이용자의 의무)
      <br />
      이용자는 다음 행위를 하여서는 안 됩니다.
      <br />
      1. 신청 또는 변경시 허위 내용의 등록
      <br />
      2. 타인의 정보 도용
      <br />
      3. “웹” 또는 “앱”에 게시된 정보의 변경 또는 서비스에 장애를 주는 행위
      <br />
      4. “회사”가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시
      <br />
      5. 리버스엔지니어링, 디컴파일, 디스어셈블 및 기타 일체의 가공행위를 통하여 서비스를 복제, 분해 또는 모방 기타
      변형하는 행위
      <br />
      6. “회사” 기타 제3자의 저작권 등 지적재산권에 대한 침해
      <br />
      7. “회사” 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
      <br />
      8. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 “웹” 또는 “앱”에 공개 또는 게시하는 행위
      <br />
      9. “회사”가 게시한 정보의 변경 또는 서비스에 장애를 주는 행위
      <br />
      10. 다른 “회원”의 개인정보 및 계정정보를 무단으로 수집, 저장, 게시, 유포하는 행위
      <br />
      11. 자동 접속 프로그램 등을 사용하는 등 정상적인 용법과 다른 방법으로 서비스를 이용하여 “회사”의 서버에 부하를
      일으켜 “회사”의 정상적인 서비스를 방해하는 행위
      <br />
      12. 본인 아닌 제3자에게 계정을 대여, 양도하는 등 접속권한을 부여하는 행위
      <br />
      13. 게시판을 도배할 목적에서 동일 또는 유사한 게시글 또는 의미가 없는 게시글을 반복적으로 게시하는 행위
      <br />
      14. “회사”의 동의 없이 영리, 영업, 광고, 홍보, 정치활동, 선거운동 등 본래의 용도 이외의 용도로 서비스를 이용하는
      행위
      <br />
      15. 기타 불법적이거나 부당한 수단과 목적에 의한 행위
      <br />
      <br />
    </div>,
    <div>
      5장 셀러판매 서비스
      <br />
      제23조(셀러판매 서비스의 이용)
      <br />
      ① 셀러판매 서비스와 관련하여 “회사”는 통신판매중개자로서 이용자(이하 본장에서의 “이용자”란 셀러판매 서비스
      이용자를 의미합니다)와 판매자 간의 자유로운 상품 등의 거래를 위한 시스템을 운영 및 관리, 제공할 뿐이므로, 이용자는
      상품 등을 구매하기 전에 반드시 판매자가 “웹” 및 “앱” 내에 작성한 상품 등의 상세 내용과 거래의 조건을 정확하게
      확인해야 합니다. 구매하려는 상품 등의 내용과 거래의 조건을 확인하지 않고 구매하여 발생한 모든 손해는 이용자 본인이
      부담합니다.
      <br />
      ② 이용자는 이 약관 및 “회사”가 서비스 화면에서 공지하는 내용을 준수하여야 하고, 이 약관 및 공지 내용을 위반하거나
      이행하지 않아 발생하는 모든 손해에 대하여 책임을 집니다.
      <br />
      ③ 이용자는 판매자와 상품 등 매매 절차에서 분쟁이 발생하면 분쟁의 해결을 위하여 성실히 임해야 하며, 분쟁해결의
      불성실로 판매자와 “회사”에 손해가 발생하면 그에 대한 모든 책임을 부담합니다.
      <br />
      ④ 이용자는 대금의 결제와 관련하여 이용자가 입력한 정보 및 그 정보와 관련하여 발생하는 제반 문제에 대한 모든 책임을
      부담합니다.
      <br />
      ⑤ “회사”는 이용자의 대금 결제 시 해당 결제수단에 대하여 정당한 사용권한이 있는지 확인할 수 있고, 이에 대한 확인이
      완료될 때까지 해당 거래의 진행을 중지할 수 있습니다.
      <br />
      ⑥ “회사”는 이용자에게 서비스가 안전하게 제공될 수 있도록 각종 설비와 자료를 관리하고, 서비스가 제공 목적에 맞게
      이용되고 있는지 여부를 확인합니다. 만약 이용자가 이용 목적을 위반한 것으로 확인되면 “회사”는 그에 대한 소명을
      이용자에게 요청할 수 있고, 주문 취소 등 필요한 조치를 할 수 있습니다.
      <br />
      ⑦ 이용자는 “회사”가 이용자의 서비스 이용 편의를 위하여 판매자 등으로부터 제공받은 상품 등 관련 정보 기타 콘텐츠를
      “웹” 및 “앱”을 통하여 제공하는 경우에도 상품 등의 구매 여부는 전적인 이용자 본인의 판단과 책임으로 결정하여야
      합니다. 이 경우 “회사”는 “회사”의 고의 또는 중과실이 없는 한 이용자의 구매 결정에 대하여 책임을 부담하지 아니
      합니다.
      <br />
      ⑧ 미성년자가 “웹” 및 “앱”을 통하여 상품 등을 구매하는 경우에 법정대리인이 해당 계약에 대하여 동의하지 아니하면,
      미성년자 본인 또는 법정대리인은 그 계약을 취소할 수 있습니다
      <br />
      <br />
    </div>,
    <div>
      제24조(결제대금예치서비스)
      <br />
      ① “결제대금예치서비스”라 함은 매매계약이 체결되고 이용자가 대금을 결제하는 경우에, 이용자의 결제대금 보호를 위하여
      “회사”가 일정 기간 동안 결제대금을 예치하는 서비스를 말합니다.
      <br />
      ② “회사”는 이용자와 판매자 간에 이루어지는 상품 등 매매의 안전성과 신뢰성을 높이고, 상품 등을 인수하기 전에 대금을
      결제해야 하는 이용자를 보호하기 위하여 결제대금예치서비스를 제공합니다.
      <br />
      ③ “회사”는 결제대금예치서비스의 제공과 관련하여 판매자 또는 이용자를 대리하는 것이 아님은 물론, 상품 등의 매매와
      관련하여 판매자 또는 이용자의 의무를 대행하는 것도 아닙니다.
      <br />
      ④ 이용자는 결제대금예치서비스를 통하여 구매대금을 결제하는 과정에서 발생하는 송금수수료 등을 부담하여야 합니다.
      <br />
      ⑤ 이용자는 “회사”가 결제대금예치서비스를 제공하는 과정에서 발생하는 이자 등에 대하여 “회사”에게 그 반환을 청구할
      수 없습니다.
      <br />
      ⑥ 결제대금예치서비스는 제25조에 정한 바에 따라 구매확정 된 경우에 종료됩니다.
      <br />
      ⑦ 이용자는 결제대금예치서비스가 종료된 이후에 해당 구매 건에 대하여 청약철회, 취소, 해제, 무효 등의 사유가 발생한
      경우 판매자와 직접 청약철회, 취소, 해제 및 환불 등에 관한 절차를 진행해야 합니다.
      <br />
      <br />
    </div>,
    <div>
      제25조(구매확정 등)
      <br />
      ① “회사”는 상품 등의 배송과 관련하여 판매자, 이용자, 배송업체 등 관련 당사자 사이에 분쟁 등이 발생하는 경우에는
      이에 관여하지 않으며 어떠한 책임도 부담하지 아니합니다. 이 경우 해당 분쟁 등은 관련 당사자가 직접 해결하여야
      합니다.
      <br />
      ② 이용자는 구매한 상품 등의 배송이 완료되었을 때로부터 일정한 기간 내에 “회사”에 대하여 구매확정, 교환 또는 반품의
      의사표시를 하여야 합니다.
      <br />
      ③ “회사”는 제2항의 구매확정 기간 내에 구매확정, 교환 또는 반품에 대한 이용자의 의사표시가 없는 경우, 해당 거래에
      대하여 이용자의 구매확정 의사표시가 있는 것으로 간주하여 자동구매확정으로 처리할 수 있습니다.
      <br />
      ④ 이용자는 구매확정이 이루어진 경우에는 “회사”에 대하여 상품 등의 하자, 미수령, 반품 등의 사유로 이의를 제기할 수
      없습니다. 구매확정 이후에 발생하는 환불, 교환 기타 판매자와 이용자 간의 모든 문제는 거래 당사자인 판매자와
      이용자가 직접 해결해야 하며, “회사”는 이에 개입하지 아니합니다.
      <br />
      <br />
    </div>,
    <div>
      제26조(셀러판매 서비스의 청약철회)
      <br />
      ① 판매자와 재화 등의 구매에 관한 계약을 체결한 이용자는 「전자상거래 등에서의 소비자보호에 관한 법률」 제13조
      제2항에 따른 계약내용에 관한 서면을 받은 날(그 서면을 받은 때보다 재화 등의 공급이 늦게 이루어진 경우에는 재화
      등을 공급받거나 재화 등의 공급이 시작된 날을 말합니다)부터 7일 이내에는 청약의 철회를 할 수 있습니다. 다만,
      청약철회에 관하여 「전자상거래 등에서의 소비자보호에 관한 법률」에 달리 정함이 있는 경우에는 동 법 규정에
      따릅니다.
      <br />
      ② 셀러판매 서비스 이용자는 재화 등을 배송 받은 경우 다음 각 호에 해당하는 경우에는 반품 및 교환을 할 수 없습니다.
      <br />
      1. 이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우(다만, 재화 등의 내용을 확인하기 위하여 포장 등을
      훼손한 경우에는 청약철회를 할 수 있습니다)
      <br />
      2. 이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우
      <br />
      3. 시간의 경과에 의하여 재판매가 곤란할 정도로 재화 등의 가치가 현저히 감소한 경우
      <br />
      4. 복제가 가능한 경우 그 원본인 재화 등의 포장을 훼손한 경우
      <br />
      5. 용역 또는 「문화산업진흥 기본법」 제2조 제5호의 디지털콘텐츠의 제공이 개시된 경우. (다만, 가분적 용역 또는
      가분적 디지털콘텐츠로 구성된 계약의 경우에는 제공이 개시되지 아니한 부분
      <br />
      에 대하여는 그러하지 아니함)
      <br />
      ③ 제2항제2호 내지 제4호의 경우에 “회사”가 사전에 청약철회 등이 제한되는 사실을 소비자가 쉽게 알 수 있는 곳에
      명기하거나 시용상품을 제공하는 등의 조치를 하지 않았다면 이용자의 청약철회 등이 제한되지 않습니다.
      <br />
      ④ 이용자는 제1항 및 제2항의 규정에 불구하고 재화 등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행된
      때에는 당해 재화 등을 공급받은 날부터 3월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회 등을
      할 수 있습니다.
      <br />
      ⑤ “회사”는 이용자로부터 교환 또는 반품의 의사표시를 받은 경우에는 즉시 그 사실을 판매자에게 통보합니다.
      <br />
      ⑥ 이용자는 교환 신청을 하더라도 판매자에게 교환할 상품의 재고가 없는 경우에는 해당 상품 등의 교환을 받을 수
      없습니다. 이 경우 해당 교환 신청은 반품으로 처리됩니다.
      <br />
      ⑦ 반품이나 교환에 필요한 배송비 및 기타 비용은 귀책사유가 있는 당사자가 부담합니다. 이 경우 상품 등의 하자 또는
      오배송으로 인한 반품이나 교환의 경우에는 판매자가 그 비용을 부담하나, 이용자의 단순 변심으로 인한 반품이나 교환의
      경우에는 이용자가 그 비용을 부담합니다.
      <br />
      ⑧ 판매자는 이용자가 배송상의 문제로 손해를 입은 경우에는 그에 대한 책임을 부담합니다.
      <br />
      ⑨ “회사”는 판매자가 이용자의 결제완료에 대한 통지를 받은 이후에도 상당 기간 배송 절차 등을 이행하지 아니하여
      이용자가 청약철회 등을 하거나 개별적인 정책으로 미리 정한 자동환불처리 사안에 해당하는 경우에는 해당 거래를
      취소하고 결제대금예치서비스 이용 중인 결제대금을 이용자에게 환불할 수 있습니다.
      <br />
      ⑩ 판매자가 이용자의 교환 또는 반품 신청에 대하여 적극적으로 임하지 않거나 이를 지연하는 경우, “회사”는 이용자에게
      그 교환 또는 반품 신청의 사유를 파악하여 정당한 사유가 있는 경우에는 해당 거래를 취소하는 한편, 예치 중인
      결제대금을 이용자에게 환불할 수 있습니다. 다만 이용자의 교환 또는 반품신청에 정당한 사유가 없는 경우에는 그러하지
      아니합니다.
      <br />
      ⑪ 이용자가 교환 또는 반품신청을 한 날로부터 14일이 지날 때까지 이미 수령한 상품을 판매자에게 반환하지 아니 하거나
      전화, 전자우편 등으로 연락되지 아니하는 경우, 해당 이용자의 교환 또는 반품 신청은 효력을 상실합니다.
      <br />
      ⑫ “회사”는 청약철회 등으로 인하여 결제대금을 환불하는 경우에는 그 청약철회 등을 한 날(단, 상품 등이 배송된
      경우에는 판매자가 상품 등을 반환 받은 날)로부터 3영업일 이내에 환불에 필요한 조치를 합니다. 신용카드로 결제가
      이루어진 경우 환불은 해당 신용카드 결제 취소를 통해서만 가능하고, 어떠한 경우에도 현금으로 환불되지는 아니합니다.
      <br />
      <br />
    </div>,
    <div>
      제27조(직거래 제한)
      <br />
      판매자와 이용자가 “회사”가 제공하는 서비스를 이용하지 아니하고 직접 거래하는 행위(직거래)는 거래의 안전을 위하여
      금지됩니다. 이 경우 직거래를 통하여 발생한 제반 문제에 대한 책임은 거래 당사자들에게 있으며 “회사”는 이에 대해
      어떠한 책임도 부담하지 아니 합니다.
      <br />
      <br />
      <br />
      제28조(셀러판매 서비스 면책)
      <br />
      ① ”회사”는 셀러판매 서비스와 관련하여, 통신판매중개자로서 이용자와 판매자 간의 자유로운 상품 등의 거래를 위한
      시스템을 운영 및 관리, 제공할 뿐 이용자 또는 판매자를 대리하지 않으며, 이용자와 판매자 사이에 성립된 거래와 관련된
      책임과 이용자가 제공한 정보에 대한 책임은 해당 이용자가 직접 부담하여야 합니다.
      <br />
      ② ”회사”는 판매자가 등록한 상품 등의 내용과 거래조건에 대해서 어떠한 보증이나 대리를 하지 않으며, 이용자는 본인의
      위험과 책임 하에 상품 등을 구매해야 합니다.
      <br />
      ③ ”회사”는 이용자와 판매자 간의 모든 행위(거래행위 포함)와 관련하여 판매의사 또는 구매의사의 존부 및 진정성, 등록
      상품의 품질, 완전성, 안정성, 적법성 및 타인의 권리에 대한 비침해성, 이용자 또는 판매자가 입력하는 정보 및 그
      정보를 통하여 연결된 웹사이트에 게재된 자료의 진실성 또는 적법성 등에 대하여 보증하지 아니하며, 이와 관련된 위험과
      책임은 해당 당사자들이 부담합니다.
      <br />
      ④ ”회사”는 이용자 및 판매자의 귀책사유로 서비스 이용에 장애가 발생하는 것에 대하여 책임을 부담하지 아니합니다.
      <br />
      ⑤ “회사”는 이용자가 본인의 개인정보를 타인에게 유출하거나 제공하여 발생하는 피해에 대하여 책임을 부담하지
      아니합니다.
      <br />
      ⑥ ”회사”는 천재지변, 컴퓨터 등 정보통신설비의 보수, 점검, 교체, 고장 및 통신두절 등의 사유가 발생한 경우에는
      서비스 제공을 일시적으로 중단할 수 있으며, 이와 관련하여 고의 또는 과실이 없는 한 어떠한 책임도 부담하지
      아니합니다.
      <br />
      ⑦ ”회사”의 고의 또는 중과실로 인한 손해에 대해서는 제1항 내지 제3항에 불구하고 “회사”가 책임을 부담합니다. 제4항
      및 제5항의 경우에는 회사의 고의 또는 과실로 인한 손해에 대해 위와 같습니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      6장 손해 배상 및 기타
      <br />
      제29조(게시물의 관리)
      <br />
      ① “웹” 및 “앱”의 게시물과 자료의 관리 및 운영의 책임은 운영자에게 있습니다. 운영자는 불량게시물 및 자료를
      모니터링하여야 하며, 불량게시물 및 자료를 발견하거나 신고를 받으면 해당 내용을 삭제하고 이를 등록한 회원에게
      주의를 주는 등 적절한 조치를 취할 수 있습니다.
      <br />
      ② 운영자는 정보통신윤리위원회 등 공공기관의 시정요구에 따라 이용자의 사전동의 없이 게시물을 삭제, 이동하거나
      열람을 제한할 수 있습니다.
      <br />
      ③ “회사”가 불가피한 사정으로 서비스를 중단하게 될 경우 회원에게 사전에 공지하고 게시물의 원활한 이전을 위하여
      노력합니다.
      <br />
      ④ 다음 각호에 해당하는 게시물은 불량게시물로 봅니다.
      <br />
      1. 제3자를 모욕하거나 제3자의 명예를 훼손하는 내용을 포함한 경우
      <br />
      2. 공공질서 및 미풍양속에 위반되는 내용을 유포하거나 링크한 경우
      <br />
      3. 불법복제 또는 해킹을 조장하는 내용인 경우
      <br />
      4. 영리를 목적으로 하는 광고일 경우
      <br />
      5. 범죄와 결부된다고 객관적으로 인정되는 내용일 경우
      <br />
      6. 다른 이용자 또는 제3자와 저작권 등 기타 권리를 침해하는 경우
      <br />
      <br />
      <br />
    </div>,
    <div>
      제30조(저작권 등의 귀속 및 이용제한)
      <br />
      ① “회사”가 작성한 저작물에 대한 저작권 기타 지적재산권은 “회사”에 귀속합니다.
      <br />
      ② 이용자는 “웹” 또는 ”앱”을 이용함으로써 얻은 정보 중 “회사”에게 지적재산권이 귀속된 정보를 “회사”의 사전 승낙
      없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.
      <br />
      ③ 회원이 작성하여 “웹” 또는 “앱”에 게시한 게시물의 저작권은 해당 회원에게 귀속되며, 해당 게시물의 저작권 침해를
      비롯한 민·형사상 책임은 회원이 부담합니다.
      <br />
      ④ “회사”는 게시물을 게시자의 동의 없이 상업적으로 이용할 수 없습니다. 단, 제5항의 경우는 이용 가능합니다.
      <br />
      ⑤ “회사”는 회원의 게시물을 다음 각호와 같이 이용할 수 있습니다.
      <br />
      1. “회사” 및 제휴사 서비스 홍보를 목적으로 “웹” 및 “앱”에 게시
      <br />
      2. “회사” 및 제휴사 서비스 홍보를 목적으로 2차적 저작물과 편집저작물로 작성
      <br />
      3. 회원이 게시물 등록 또는 회원정보 작성시 허락한 범위 내에서의 게시물 복제, 전송, 전시, 배포
      <br />
      4. 게시물 검색 서비스 향상을 위한 게시물 자료(제목, 내용, 게시자ID, 게시일, 조회수) 복제, 전송(회원 ID를 제외한
      개인정보는 이용되지 않으며, 복제, 전송받은 자는 “회사”가 지정한 목적으로만 해당 자료를 이용할 수 있습니다)
      <br />
      ⑥ “회사”가 회원에게 귀속된 저작권을 사용하는 경우 당해 회원에게 통보하고, 게시자가 게시물의 삭제 또는 사용중지를
      요청하면 “회사”는 관련 법률에 따라 보존해야 하는 사항을 제외하고는 즉시 삭제 또는 사용을 중지합니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제31조(손해배상 및 면책)
      <br />
      ① “회사”의 재화 등 제공에 관하여 이용자의 고의 또는 과실로 인하여 발생한 손해는 해당 이용자가 민형사상 책임을
      부담합니다.
      <br />
      ② “회사”의 반려동물 소변검사, 모발검사, 유전병 검사 서비스는 반려동물의 전반적인 건강상태 확인과 이상징후 감지를
      주목적으로 하므로 정확한 질병진단을 위하여 수의사 등 전문가와 별도로 상담하여야 하며, 서비스 결과는 전문가의
      최종진단과 다를 수 있습니다. “회사”는 서비스 결과와 전문가의 최종진단이 일치하지 아니함으로 인한 손해를 배상하지
      않습니다.
      <br />
      ③ “회사”는 다음 각 호의 사유로 인하여 발생한 손해를 배상하지 않습니다.
      <br />
      1. 회원이 저장, 게시 또는 전송한 자료로 인하여 발생한 손해
      <br />
      2. 천재지변 등 불가항력으로 인하여 발생한 손해
      <br />
      3. 서비스용 설비의 보수, 교체, 정기점검, 공사 등 기타 이에 준하는 사유로 서비스 이용이 불가한 경우
      <br />
      4. “회원”이 계정 비밀번호, 모바일 기기 비밀번호 등 개인정보를 적절하게 관리하지 않아 회원정보의 유출이 발생한 경우
      <br />
      5. “회사”가 제공하는 서비스 중의 배너 또는 링크 등을 통해 타인이 제공하는 광고나 서비스에 연결된 경우, 해당
      영역에서 제공하는 정보 또는 서비스로 인하여 발생한 손해
      <br />
      6. 서버 등 설비의 관리, 점검, 보수, 교체 과정 또는 소프트웨어의 운용 과정에서 고의 또는 고의에 준하는 중대한 과실
      없이 발생할 수 있는 시스템의 장애, 제3자의 공격으로 인한 시스템의 장애, 국내외의 저명한 연구기관이나 보안관련
      업체에 의해 대응방법이 개발되지 아니한 컴퓨터 바이러스 등의 유포나 기타 운영자가 통제할 수 없는 불가항력적 사유로
      인한 회원의 손해
      <br />
      7. “회사”가 “웹”, “앱” 또는 제품설명서 등을 통하여 고지한 주의사항을 준수하지 아니함으로 인하여 발생한 손해
      <br />
      8. 기타 이용자의 고의 또는 과실로 인하여 발생한 손해
      <br />
      <br />
      <br />
    </div>,
    <div>
      제32조(분쟁해결)
      <br />
      ① “회사”는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 이용자의 의견이나
      불만을 제시하는 방법을 “웹” 및 “앱”의 서비스화면 또는 그 연결화면에 안내합니다. 회사는 이러한 이용자의 의견이나
      불만을 처리하기 위한 전담인력을 운영합니다.
      <br />
      ② “회사”는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한
      경우에는 이용자에게 그 사유와 처리일정을 즉시 통보합니다.
      <br />
      ③ “회사”와 이용자 간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는
      시·도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.
      <br />
      <br />
      <br />
    </div>,
    <div>
      제33조(재판권 및 준거법)
      <br />
      ① “회사”와 이용자 간에 발생한 전자상거래 분쟁에 관한 소송의 관할은 민사소송법에 따릅니다. 다만, 제소 당시 이용자의
      주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 서울중앙지방법원을 관할로 합니다.
      <br />
      ② 이 약관은 대한민국 법률에 따라 규율되고 해석됩니다. “회사”와 이용자 간에 발생한 분쟁으로 소송이 제기되는 경우 그
      소송에는 대한민국 법을 적용합니다.
      <br />
      <br />
      <br />
      부칙 1.
      <br />
      <br />
      1. 이 약관은 <span>2026 년 6 월 1 일</span>부터 시행합니다.
      <br />
      2. 종전의 약관은 이 약관으로 대체됩니다.
      <br />
      <br />
      <br />
      부칙 2. 핏펫 플러스 유료 멤버십 종료 및 전환에 관한 특례
      <br />
      <br />
      1. 시행일: 이 부칙은 <span>2026 년 7 월 1 일</span>부터 시행합니다.
      <br />
      2. 종료: 회사는 서비스 개편에 따라 유료 멤버십 (핏펫 플러스)을 2026 년 7 월 1 일자로 일괄 종료합니다.
      <br />
      3. 환불: 유료 구독 중인 회원에 대하여 잔여 구독 기간의 월할 환불을 결제 원수단으로 처리합니다.
      <br />
      4. 보상: 유료 구독자 전원에게 전환 보상 혜택을 제공하며, 세부 내용은 별도 공지합니다.
      <br />
      5. 위약금 면제: 이번 종료는 회사 귀책에 의한 해지이므로 위약금을 부과하지 않습니다.
      <br />
      <br />
    </div>,
  ]
  return (
    <div style={{ padding: 10, paddingTop: 40 }}>
      {textSplitList.map((text) => {
        return (
          <TextLegacy size={fontSize} style={{ display: 'inline-block' }}>
            {text}
          </TextLegacy>
        )
      })}
    </div>
  )
}

export default PolicyAgreement
